import GoogleMapReact from 'google-map-react';
import React, { useState } from 'react';
import { stylesMap } from 'shared/sections/Map/constants.styles';
import coordinates from 'shared/sections/Map/coordinates.json';
import CustomMarker from 'shared/sections/Map/MapCustomMarker';

import cn from './style.module.sass';

type SimpleMapProps = {
    showMap: boolean;
    currentCity: string;
};

export default function MapBody({ showMap, currentCity }: SimpleMapProps) {
    const currentCoordinates = coordinates[currentCity as keyof typeof coordinates];
    const [opacity, setOpacity] = useState(1);

    return (
        showMap && (
            <div className={cn['main-map__body']}>
                <GoogleMapReact
                    center={currentCoordinates.center}
                    defaultZoom={currentCoordinates.zoom}
                    options={{
                        styles: stylesMap,
                        scrollwheel: true,
                        disableDefaultUI: true,
                        disableDoubleClickZoom: true,
                        draggable: true,
                    }}
                    onDrag={() => setOpacity(0)}
                    onDragEnd={() => setOpacity(1)}
                    /* eslint-disable-next-line no-secrets/no-secrets */
                    bootstrapURLKeys={{ key: 'AIzaSyD8cj7fpEZjFIjCpWTM1pikvmfFffFweVw' }}
                >
                    <CustomMarker
                        opacity={opacity}
                        title={currentCoordinates.title}
                        lat={currentCoordinates.center.lat}
                        lng={currentCoordinates.center.lng}
                    />
                </GoogleMapReact>
            </div>
        )
    );
}
